import {DeleteOutlined, EditOutlined, SearchOutlined} from '@ant-design/icons'
import {Table, Button as AntdButton, message, TablePaginationConfig} from 'antd'
import React, {useState} from 'react'
import {Plant, PlantWithProjectName} from '../../entities/plant'
import {instance as plantsService} from '../../services/PlantsService'
import {useNavigate, useRevalidator, useRouteLoaderData} from 'react-router-dom'
import {useIntl} from 'react-intl'
import type {ColumnsType} from 'antd/es/table/interface'
import {TableSearchFilter} from '../TableSearchFilter'
import {TableSearchDataFilter} from '../TableSearchDataFilter'
import {Link} from 'react-router-dom'
import {PlantModal} from '../plantForm/PlantModal'
import {useMousePositionContext} from '../plantForm/usePlantModalMousePosition'
import './plantsTable.less'

export type PlantsTableProps = {
  plants: PlantWithProjectName[]
  isLoading: boolean
  getPlantLink: (plant: Plant) => string
  parentRoute: string
  newPlantRoute: string
  loadMore?: () => void
  hasMore?: boolean
  isLoadingMore?: boolean
}

export function PlantsTable({
  plants,
  isLoading,
  getPlantLink,
  parentRoute,
  newPlantRoute,
}: PlantsTableProps) {
  const [isOpenForm, setIsOpenForm] = useState(false)
  const [currentPlant, setCurrentPlant] = useState<Plant | null>(null)
  const revalidator = useRevalidator()
  const [messageApi, contextHolder] = message.useMessage()
  const {projectNames} = useRouteLoaderData('root') as {projectNames: {id: number; name: string}[]}
  const intl = useIntl()
  const {setMousePosition} = useMousePositionContext()
  const navigate = useNavigate()

  const columns: ColumnsType<PlantWithProjectName> = [
    {
      title: intl.formatMessage({id: 'name'}),
      key: 'name',
      render: (plant) => (
        <div>
          <Link
            to={getPlantLink(plant)}
            onClick={(e) => setMousePosition({x: e.pageX, y: e.pageY})}
          >
            {plant.name}
          </Link>
          {plant.plantBaseId && (
            <div>
              ({plant.fields['Общераспространенное название']}
              {plant.fields['Сорт_eng'] || plant.fields['Сорт_ru']
                ? ` ${plant.fields['Сорт_eng']}`
                  ? ` ${plant.fields['Сорт_eng']}`
                  : ` ${plant.fields['Сорт_ru']}`
                : ''}
              )
            </div>
          )}
        </div>
      ),
      // filterDropdown: ({setSelectedKeys, selectedKeys, confirm, clearFilters, close}) => {
      //   return (
      //     <div style={{padding: 8}}>
      //       <TableSearchFilter
      //         filterValue={selectedKeys[0] as string}
      //         onFilterValueSet={(value) => {
      //           if (value === '') {
      //             clearFilters()
      //             confirm()
      //           } else {
      //             setSelectedKeys([value])
      //             confirm()
      //           }
      //         }}
      //       />
      //     </div>
      //   )
      // },
      // filterIcon: (filtered: boolean) => (
      //   <SearchOutlined style={{color: filtered ? '#1677ff' : undefined}} />
      // ),
    },
    {
      title: intl.formatMessage({id: 'dateOfPlanting'}),
      dataIndex: 'dateOfPlantingUtc',
      key: 'dateOfPlantingUtc',
      render: (value) => (value ? String(value) : ''),
      // filterDropdown: ({setSelectedKeys, selectedKeys, confirm, clearFilters, close}) => {
      //   return (
      //     <div style={{padding: 8}}>
      //       <TableSearchDataFilter
      //         filterValue={selectedKeys[0] as string}
      //         onFilterValueSet={([startDate, endDate]) => {
      //           if (!startDate && !endDate) {
      //             clearFilters()
      //             confirm()
      //           } else {
      //             setSelectedKeys([startDate, endDate])
      //             confirm()
      //           }
      //         }}
      //       />
      //     </div>
      //   )
      // },
      // filterIcon: (filtered: boolean) => (
      //   <SearchOutlined style={{color: filtered ? '#1677ff' : undefined}} />
      // ),
    },
    // {
    //   title: intl.formatMessage({id: 'description'}),
    //   dataIndex: 'description',
    //   key: 'description',
    // },
    {
      title: intl.formatMessage({id: 'collections'}),
      dataIndex: 'collections',
      key: 'collections',
      render: (value) => {
        if (value.length >= 1) {
          return value.map((collection) => collection.name).join(', ')
        }
      },
    },
    {
      title: intl.formatMessage({id: 'project'}),
      dataIndex: 'projectName',
      key: 'projectName',
      render: (projectName, plant) =>
        plant.gardenPlanVariantName
          ? `${projectName} (${plant.gardenPlanVariantName})`
          : projectName,
    },
    {
      title: intl.formatMessage({id: 'comment'}),
      dataIndex: 'comment',
      key: 'comment',
    },
    // {
    //   title: intl.formatMessage({id: 'actions'}),
    //   render: (value) => (
    //     <div>
    //       <AntdButton
    //         type="link"
    //         onClick={(event) => {
    //           setCurrentPlant(value)
    //           setIsOpenForm(true)
    //         }}
    //       >
    //         <EditOutlined />
    //       </AntdButton>
    //     </div>
    //   ),
    // },
  ]

  return (
    <div>
      {contextHolder}
      {/* <AntdButton
        type="link"
        style={{float: 'right'}}
        onClick={() => {
          navigate(newPlantRoute + location.search)
        }}
      >
        {intl.formatMessage({id: 'addPlant'})}...
      </AntdButton> */}
      <Table
        id="plants-table"
        onRow={(plant) => ({
          onClick: (e) => {
            setMousePosition({x: e.pageX, y: e.pageY})
            navigate(getPlantLink(plant) + location.search)
          },
        })}
        rowClassName="plants-table-row"
        rowKey="id"
        dataSource={plants.filter((plant) => {
          if (!plant.isPlantDeleted) {
            return {...plant, key: plant.id}
          }
        })}
        columns={columns}
        loading={isLoading}
        pagination={false}
        scroll={{x: 'max-content'}}
      />
      <PlantModal routeWhenClosed={parentRoute + location.search} />
    </div>
  )
}
